// =====================================
//
//   確認退款 Modal
//   Author: Gray
//   createtime: 2016 / 03 / 29
//   updatetime: 2016 / 03 / 29
//
// =====================================
// confirum_refund
window.InifECMobileApp.directive('confirmRefund', ['$rootScope', '$stateParams', '$timeout', '$ngModal', 'OrderService',
    function($rootScope, $stateParams, $timeout, $ngModal, OrderService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            // --------------------------------
            // [private] 打開 Modal
            // --------------------------------
            var openModal = function() {

                $ngModal.openModal('confirm-refund-modal');
            }

            // --------------------------------
            // [private] 關閉 Modal
            // --------------------------------
            var closeModal = function() {

                $ngModal.closeModal('confirm-refund-modal');
            }

            // --------------------------------
            // 退款
            // --------------------------------
            var confirmRefund = function(){

                if($scope.isRefunding){
                    return;
                }

                $scope.isRefundIssueEmpty = false;
                $scope.isRefundingError = false;

                if(!$scope.form.refundIssue || $scope.form.refundIssue == '') {
                    $scope.isRefundIssueEmpty = true;
                    return;
                } 

                $scope.isRefunding = true;

                OrderService.refundOrder($scope.orderid, $scope.form.refundIssue, $scope.form.file).then(function(result) {

                    if(result){
                        ($scope.callback) && $scope.callback();
                        closeModal();
                        openSuccessMoadl()
                    } else {
                        $scope.isRefundingError = true;
                    }

                    $scope.isRefunding = false;

                }, function(error){
                   
                    $scope.isRefundingError = true;
                    $scope.isRefunding = false;
                });
            }

            // --------------------------------
            // 選擇附件
            // --------------------------------
            var onRefundFileSelect = function($files) {

                if(!Array.isArray($files) || $files.length == 0) {
                    return;
                }

                $scope.form.file = $files[0];
            }

            // --------------------------------
            // 移除附件
            // --------------------------------
            var removeFile = function() {

                $scope.form.file = undefined;
            }

            var openSuccessMoadl = function() {

                $rootScope.$broadcast("OPEN_SUCCESS_MESSAGE_MODAL", {
                    title: "已成功申請退貨",
                    desc: "我們已收到您的退貨申請，客服人員將會與您聯繫，請耐心等候。"
                });
            }

            // --------------------------------
            // [private] 初始化
            // --------------------------------
            var init = function() {

            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_CONFIRM_REFUND_MODAL", function(event, data) {

                if(data) {
                    $scope.orderid = data.orderid;
                    $scope.callback = data.callback;

                    $scope.form.refundIssue = '';
                    $scope.form.file = undefined;

                    openModal();    
                }
            });
                
            /*==========================
                Members
            ==========================*/
            $scope.form = {
                refundIssue: '',
                file: undefined
            };
            $scope.isRefundIssueEmpty = false;
            $scope.isRefundingError = false;

            /*==========================
                Methods
            ==========================*/
            $scope.callback = undefined;
            $scope.confirmRefund = confirmRefund; // 退款
            $scope.onRefundFileSelect = onRefundFileSelect; // 選擇附件
            $scope.removeFile = removeFile; // 移除附件

            /*==========================
                init
            ==========================*/

            init();

        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'mobile/partials/modal/confirm_refund.html';
        _dir.controller = controller;

        return _dir;
}]);